import { createRouter, createWebHistory } from 'vue-router'
import Layout from '../layout/index.vue'

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/organization',
    children: [
      {
        path: 'organization',
        name: 'Organization',
        component: () => import('../views/organization/index.vue'),
        meta: { title: '组织管理' }
      },
      {
        path: 'business',
        name: 'Business',
        component: () => import('../views/business/index.vue'),
        meta: { title: '业务管理' }
      },
      {
        path: 'device',
        name: 'Device',
        component: () => import('../views/device/index.vue'),
        meta: { title: '设备管理' }
      },
      {
        path: 'preview',
        name: 'Preview',
        component: () => import('../views/preview/index.vue'),
        meta: { title: '实时预览' }
      },
      {
        path: 'storage',
        name: 'Storage',
        component: () => import('../views/storage/index.vue'),
        meta: { title: '存储配置' }
      },
      {
        path: 'annotate',
        name: 'Annotate',
        component: () => import('../views/annotate/index.vue'),
        meta: { title: '图片标注' }
      },
      {
        path: 'local',
        name: 'LocalAnnotate',
        component: () => import('../views/annotate/local/index.vue'),
        meta: { title: '本地标注' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router






